import {Component, OnInit} from '@angular/core';
import {Favorite, FavoriteList} from '@models/favorite';
import {AdService} from '@services/ad.service';
import {EMPTY_FAVORITE_LIST, EVOL_DEMO_LAST_YEAR} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {AlertService} from '@services/alert.service';
import {CityService} from '@services/city.service';
import {ImageService} from '@services/image.service';

@Component({
    selector: 'app-historic',
    templateUrl: './historic.component.html',
    styleUrls: ['./historic.component.scss']
})
export class HistoricComponent implements OnInit {

    favoritesList: FavoriteList = EMPTY_FAVORITE_LIST;
    favorites: Favorite[] = [];
    loading = true;
    displayedColumns: string[] = [];
    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;

    constructor(
        public authenticationService: AuthenticationService,
        public adService: AdService,
        private alertService: AlertService,
        public trackingService: TrackingService,
        public cityService: CityService,
        public imageService: ImageService,
    ) {
    }

    ngOnInit() {
        if (this.authenticationService.currentUser.user_dashboard.favorite_kpi === undefined || this.authenticationService.currentUser.user_dashboard.favorite_kpi === null || this.authenticationService.currentUser.user_dashboard.favorite_kpi.length == 0 || !this.authenticationService.isAllowed('expert')) {
            this.displayedColumns = ['ad_city.price_diff', 'ad_city.demographie_annuelle', 'ad_city.carac_commune.mv', 'favorite.ad_city.renta', 'ad_city.carac_commune.te', 'ad_city.advice_price', 'amount_rent', 'ad_city.carac_commune.tc'];
        } else {
            this.displayedColumns = this.authenticationService.currentUser.user_dashboard.favorite_kpi;
        }
        this.loading = true;
        this.adService.getFavoritesList('historic').subscribe(result => {
            result.favorites.forEach((fav, i) => {
                result.favorites[i] = this.adService.updateValues(fav);
            });
            this.favoritesList = result;
            this.favorites = result.favorites;
            this.loading = false;
        }, error => {
            if (error != 'token_outdate') {
                this.alertService.error('Liste introuvable');
            }
        });
    }
}
